import React from 'react';
import { ArrowRight } from 'lucide-react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  withArrow?: boolean;
}

export const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  withArrow = false,
  className = '',
  ...props 
}) => {
  const baseStyles = "inline-flex items-center justify-center px-10 py-4 text-sm font-black tracking-widest uppercase transition-all duration-500 rounded-full group";
  
  const variants = {
    primary: "bg-white text-black hover:bg-zinc-200 border border-white",
    secondary: "bg-zinc-900 text-white hover:bg-white hover:text-black border border-zinc-800",
    outline: "bg-transparent text-white border-2 border-white hover:bg-white hover:text-black",
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${className}`} 
      {...props}
    >
      <span className="relative z-10">{children}</span>
      {withArrow && (
        <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-500 group-hover:translate-x-2" />
      )}
    </button>
  );
};